import axios from '@/libs/api.request'

// 提交分拣数据进行装箱
export const doPackingBoxByPackIds = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/doPackingBoxByPackIds',
		data,
		method: 'post',
	})
};

// 查询装箱箱子列表
export const queryPackingBoxList = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/queryPackingBoxList',
		params: data,
		method: 'get',
	})
};

// 取消装箱
export const doCancelBox = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/doCancelBox',
		data,
		method: 'post',
	})
};

// 查询可加入的箱子
export const queryCanJoinBoxList = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/queryCanJoinBoxList',
		params: data,
		method: 'get',
	})
};

// 加入已有箱子
export const doJoinBox = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/doJoinBox',
		data,
		method: 'post',
	})
};

// 查询订单装箱数据
export const queryBoxListByOrder = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/queryBoxListByOrder',
		params: data,
		method: 'get',
	})
};

// 调换箱
export const doChangeBox = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/doChangeBox',
		data,
		method: 'post',
	})
};

// 查询订单装箱数据明细
export const queryBoxListDetailByOrder = (data) => {
	return axios.request({
		url: '/api/v1/packingBox/queryBoxListDetailByOrder',
		params: data,
		method: 'get',
	})
};



// WEBPACK FOOTER //
// ./src/api/sorting/packingBox.js